// extracted by mini-css-extract-plugin
module.exports = {"signup-page":"styles_signup-page__2H33h","content":"styles_content__26qCb","body":"styles_body__3H4gc"};